import React from "react";
import { Avatar } from "antd";

import type { TypeLenderContactPerson } from "../../../hooks/useContact";

import { ICON } from "../../GuidelineSelect/GuidelineCheckbox";

export interface TypeTitleProps {
  lenderId: string;
  lenderName: string;
  lenderDisplayName: string;
  contacts: TypeLenderContactPerson[];
}

/**
 * @name Title Lender标题
 */
const Title: React.FC<TypeTitleProps> = ({ lenderDisplayName, contacts }) => {
  const LENGTH = contacts?.length;
  return (
    <div className="scenario-contact-lender">
      <div>
        <img src={ICON[lenderDisplayName]} />
        <div className="scenario-contact-lender-name">
          <p>{lenderDisplayName}</p>
          <p>
            {LENGTH} contact{LENGTH > 1 ? "s" : ""}
          </p>
        </div>
      </div>
      <div className="scenario-contact-lender-desc">
        {LENGTH ? (
          <Avatar.Group size="small" className="scenario-contact">
            {contacts.slice(0, 2).map((v) => (
              <Avatar key={v.id}>
                {v.first_name?.[0]}
                {v.last_name?.[0]}
              </Avatar>
            ))}
            {LENGTH > 2 && <Avatar>+{LENGTH - 2}</Avatar>}
          </Avatar.Group>
        ) : null}
      </div>
    </div>
  );
};

export default Title;
